import { useQuery } from '@tanstack/react-query';

import { listActionRewardConfigs } from '~/services/LoyaltyService';

import { actionRewardConfigQueryKeys } from './actionRewardConfigQueryKeys';

interface UseGetActionRewardConfigsParams {
  enabled?: boolean;
}

/** Fetch all action reward configs. Filtering is client-side in the grid. */
export function useGetActionRewardConfigs({ enabled = true }: UseGetActionRewardConfigsParams = {}) {
  return useQuery({
    queryKey: actionRewardConfigQueryKeys.list(),
    queryFn: ({ signal }) => listActionRewardConfigs({ signal }),
    enabled,
    staleTime: 30_000,
  });
}
